export default __webpack_public_path__ + "static/rec-2013-28ad4f1c92d1b64e245cfaa18d02ff98.png";